import { useEffect } from 'react'
import { useTheme } from '../contexts/ThemeContext'

interface ToastNotificationProps {
  message: string
  type?: 'success' | 'error' | 'info'
  isVisible: boolean
  onClose: () => void
  duration?: number
}

export default function ToastNotification({
  message,
  type = 'success',
  isVisible,
  onClose,
  duration = 3000,
}: ToastNotificationProps) {
  const { theme } = useTheme()

  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        onClose()
      }, duration)

      return () => clearTimeout(timer)
    }
  }, [isVisible, duration, onClose])

  if (!isVisible) return null

  const bgColor =
    type === 'success'
      ? theme === 'dark'
        ? 'bg-green-600/90'
        : 'bg-green-500/90'
      : type === 'error'
      ? theme === 'dark'
        ? 'bg-red-600/90'
        : 'bg-red-500/90'
      : theme === 'dark'
      ? 'bg-blue-600/90'
      : 'bg-blue-500/90'

  const icon =
    type === 'success' ? 'pi pi-check-circle' : type === 'error' ? 'pi pi-times-circle' : 'pi pi-info-circle'

  return (
    <div
      className={`fixed top-4 right-4 z-[100] ${bgColor} text-white px-6 py-4 rounded-lg shadow-2xl flex items-center gap-3 min-w-[300px] max-w-md toast-slide-in`}
    >
      <i className={`${icon} text-xl`}></i>
      <span className="flex-1 font-medium">{message}</span>
      <button
        onClick={onClose}
        className="text-white/80 hover:text-white transition"
        aria-label="Close"
      >
        <i className="pi pi-times text-sm"></i>
      </button>
    </div>
  )
}

